import React, { Component  } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Card, Modal, Accordion } from "react-bootstrap";
import { FaAngleDown } from 'react-icons/fa';
import moment from 'moment';

export default class ChemoList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientId: this.props.patientId
        };
    }
    
    render() {
        const { showChemoList, closeModal } = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const dateFormat = 'DD/MM/yyyy';
        return (
                <div id="mySidepanel" className="sidepanel shadow-lg" show={showChemoList ? "true" : "false"}>
                    <Modal.Header closeButton onClick={() => closePreviewModal()} style={{ backgroundColor: '#7fd1ba6b', borderColor: '#7fd1ba6b' }}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Previous Chemo Details</h3> 
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid className='p-2'>
                            <Row>
                                <Col lg='12'>
                                    <Accordion id="chemoSitting">
                                        {this.props.patAllChemoSittings
                                            .sort((a, b) => (new Date(b.chemoDt)) - (new Date(a.chemoDt)))
                                            .map(function (d, idx) {
                                                return (
                                                    <Card key={idx}>
                                                        <Accordion.Toggle className="followup-ReportCard mb-0 p-3" eventKey={idx + 1}><FaAngleDown className="fs-18 mr-1" /> Sitting - {moment(d.chemoDt).format(dateFormat)}</Accordion.Toggle>
                                                        <Accordion.Collapse eventKey={idx + 1}>
                                                            <Card.Body>
                                                                <Form.Group as={Row} controlId="formPlaintextEmail">
                                                                    <Form.Label column sm="3">
                                                                        Chemo Sitting Date
                                                                    </Form.Label>
                                                                    <Col sm="3">
                                                                        <Form.Control className='readOnlyView inline' readOnly defaultValue={moment(d.chemoDt).format(dateFormat)} />
                                                                    </Col>
                                                                    {/* <Form.Label column sm="3">
                                                                        Cycle
                                                                    </Form.Label>
                                                                    <Col sm="3">
                                                                        <Form.Control className='readOnlyView inline' readOnly defaultValue={d.chemoCycleNumber} />
                                                                    </Col> */}
                                                                </Form.Group>
                                                                <Form.Group as={Row} controlId="formPlaintextEmail">
                                                                    {/* <Form.Label column sm="3">
                                                                        Planned Cycle Date
                                                                    </Form.Label>
                                                                    <Col sm="3">
                                                                        <Form.Control className='readOnlyView inline' readOnly defaultValue={moment(d.chemoPlannedDt).format(dateFormat)} />
                                                                    </Col> */}
                                                                    <Form.Label column sm="3">
                                                                        Delay in this Cycle
                                                                    </Form.Label>
                                                                    <Col sm="3">
                                                                        <Form.Control className='readOnlyView inline' readOnly defaultValue={d.delay == 'Y' ? 'Yes' : 'No'} />
                                                                    </Col>
                                                                </Form.Group>
                                                                {/* <Form.Group as={Row} controlId="formPlaintextEmail">
                                                                    <Form.Label column sm="3">
                                                                        Next Chemo Date
                                                                    </Form.Label>
                                                                    <Col sm="3">
                                                                        <Form.Control className='readOnlyView inline' readOnly defaultValue={moment(d.nextChemoCycleDate).format(dateFormat)} />
                                                                    </Col>
                                                                </Form.Group> */}
                                                                <Form.Group as={Row} controlId="formPlaintextEmail">
                                                                    <Form.Label column sm="3">
                                                                        Treatement Given
                                                                    </Form.Label>
                                                                    <Col sm="9">
                                                                        <p className='readOnlyView inline' readOnly>{d.treatmentGiven}</p>
                                                                    </Col>
                                                                </Form.Group>
                                                                <Form.Group as={Row} controlId="formLinks">
                                                                    <Col sm="12">
                                                                        <Link className="dropdown-item" target='_blank' to={{ pathname: '/ChemoTemplate', search: 'p=' + d.patChemoSittingId }}>
                                                                            <strong>Doctor Report</strong>
                                                                        </Link>
                                                                        <Link className="dropdown-item" target='_blank' to={{ pathname: '/ChemoTemplateForNurse', search: 'p=' + d.patChemoSittingId }}>
                                                                            <strong>Nurse Report</strong>
                                                                        </Link>
                                                                        <Link className="dropdown-item" target='_blank' to={{ pathname: '/ChemoTemplateForPatient', search: 'p=' + d.patChemoSittingId }}>
                                                                            <strong>Patient Report</strong>
                                                                        </Link>
                                                                        <Link className="dropdown-item" target='_blank' to={{ pathname: '/ChemoTemplateForPharmacist', search: 'p=' + d.patChemoSittingId }}>
                                                                            <strong>Pharmacist Report</strong>
                                                                        </Link>
                                                                        <Link className="dropdown-item" target='_blank' to={{ pathname: '/CurrentDischargeSummary', search: 'p=' + d.patChemoSittingId }}>
                                                                            <strong>Discharge Summary</strong>
                                                                        </Link>
                                                                    </Col>
                                                                </Form.Group>

                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                )
                                            })}
                                    </Accordion>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                </div>
        )
    }
}